"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.alias = void 0;
var scale = [12, 16, 32, 64];
var alias = {
  small: scale[0],
  medium: scale[1],
  large: scale[2],
  extraLarge: scale[3]
};
exports.alias = alias;
var _default = {
  scale: scale,
  alias: alias
};
exports.default = _default;